<template>
    <CheckinPart></CheckinPart>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const CheckinPart = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/EngineeringWorkbench/CheckinPart.vue"
    )
);

export default {
    name: "Project_HelpCheckinPart", //The name you are in should not equal the name of the component you are importing.
    components: { CheckinPart, AuthLayout },
};
</script>
